import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
// API services
import { getProfileDetail, updateProfile, sendPasswordOTP, verifyPasswordOTP } from '../../services/profile';
import { getBanks } from '../../services/master';
import { showSnackbar } from '../../components/Snackbar';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  Avatar,
  Tabs,
  Tab,
  Divider,
  IconButton,
  Chip,
  Switch,
  FormControlLabel,
  Autocomplete,
  InputAdornment,
} from '@mui/material';
import {
  Person as PersonIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
  Save as SaveIcon,
  Edit as EditIcon,
  Lock as LockIcon,
  CameraAlt as CameraIcon,
  AccountBalance as BankIcon,
  Badge as BadgeIcon,
  CalendarMonth as CalendarIcon,
  AccountCircle as AccountCircleIcon,
  Info as InfoIcon,
  Payment as PaymentIcon,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';
import { hasWritePermission, hasReadPermission } from '../../utils/menuFilter';
import AvatarMui from '@mui/material/Avatar';
import WarningIcon from '@mui/icons-material/Warning';

const TabPanel = ({ children, value, index, ...other }) => (
  <div role="tabpanel" hidden={value !== index} {...other}>
    {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
  </div>
);

const MyProfile = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userRole, setUserRole] = useState('associate');
  const [successMessage, setSuccessMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [personalErrors, setPersonalErrors] = useState({});
  const [bankErrors, setBankErrors] = useState({});
  const [nomineeErrors, setNomineeErrors] = useState({});
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [profileData, setProfileData] = useState(null);

  // Nested editable sections state
  const [sponsorState, setSponsorState] = useState({
    sponsorName: '',
    designation: '',
    sponsorId: '',
    idCard: '',
    email: '',
    phone: '',
    city: '',
    state: ''
  });
  const [registrationState, setRegistrationState] = useState({ registrationDate: '', deActivationDate: '' });
  const [otherState, setOtherState] = useState({ employeeType: '', department: '', trialLastDate: '' });
  const [personalState, setPersonalState] = useState({ fatherName: '', dob: '', anniversary: '', qualification: '', addressNumber: '', pan: '' });
  const [bankState, setBankState] = useState({ accountName: '', bank: '', accountNumber: '', ifsc: '' });
  const [nomineeState, setNomineeState] = useState({ name: '', phone: '', relation: '' });
  const [statusState, setStatusState] = useState(true);
  const [bankList, setBankList] = useState([]);

  // Profile data
  const [profile, setProfile] = useState({
    // firstName: 'John',
    // lastName: 'Doe',
    // email: '',
    // phone: '+91-9876543210',
    // mobile: '+91-9876543210',
    // address: '123 Main Street',
    // city: 'Bangalore',
    // state: 'Karnataka',
    // country: 'India',
    // postalCode: '560100',
    // dateOfBirth: '1990-01-15',
    // joiningDate: '2020-03-10',
    // designation: 'Senior Manager',
    // department: 'IT',
    // employeeId: 'EMP12345',
    // reportingTo: 'Jane Smith',

    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    mobile: '',
    address: '',
    city: '',
    state: '',
    // country: '',
    postalCode: '',
    dateOfBirth: '',
    joiningDate: '',
    designation: '',
    department: '',
    employeeId: '',
    reportingTo: '',
  });





  // Password change data
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [avatarPreview, setAvatarPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatarPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const storedUser = window.localStorage.getItem('user');
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser && parsedUser.role) {
          setUserRole(parsedUser.role);
        }
      }
    } catch (error) {
      console.error('Failed to read user role from storage', error);
    }
  }, []);

  // Fetch profile details from backend
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoadingProfile(true);
        setFetchError('');
        const body = await getProfileDetail();
        const data = body?.data || body;
        setProfileData(data || null);

        // Normalize into our local profile shape safely
        const fullName = data?.name || `${data?.firstName || ''} ${data?.lastName || ''}`.trim();
        const [firstName = '', lastName = ''] = fullName.split(' ');
        const reg = Array.isArray(data?.registrationDetail) && data.registrationDetail[0] ? data.registrationDetail[0] : {};
        const personal = Array.isArray(data?.personalDetail) && data.personalDetail[0] ? data.personalDetail[0] : {};
        const reportingTo = Array.isArray(data?.sponsorDetail) && data.sponsorDetail[0] ? (data.sponsorDetail[0]?.sponsorName || '') : '';

        setProfile((prev) => ({
          ...prev,
          firstName: firstName || prev.firstName,
          lastName: lastName || prev.lastName,
          email: data?.email || prev.email,
          phone: data?.phone || prev.phone,
          mobile: data?.whatsapp || prev.mobile,
          address: data?.address || prev.address,
          city: data?.city || prev.city,
          state: data?.state || prev.state,
          country: data?.country || prev.country,
          postalCode: data?.postalCode || prev.postalCode,
          dateOfBirth: personal?.dob || prev.dateOfBirth,
          joiningDate: reg?.registrationDate || prev.joiningDate,
          designation: data?.designation || prev.designation,
          department: (Array.isArray(data?.otherDetail) && data.otherDetail[0]?.department) || prev.department,
          employeeId: String(data?.associateId || data?._id || prev.employeeId),
          loginId: String(data?.credentials?.loginId || prev.loginId),
          reportingTo: reportingTo || prev.reportingTo,
        }));

        // Initialize nested editable states
        const sponsor0 = (Array.isArray(data?.sponsorDetail) && data.sponsorDetail[0]) || data.sponsorBy || {};
        const reg0 = (Array.isArray(data?.registrationDetail) && data.registrationDetail[0]) || {};
        const other0 = (Array.isArray(data?.otherDetail) && data.otherDetail[0]) || {};
        const personal0 = (Array.isArray(data?.personalDetail) && data.personalDetail[0]) || {};
        const bank0 = (Array.isArray(data?.bankDetail) && data.bankDetail[0]) || {};
        const nominee0 = (Array.isArray(data?.nomineeDetail) && data.nomineeDetail[0]) || {};
        setSponsorState({
          sponsorName: sponsor0.sponsorName || sponsor0.name || '',
          designation: sponsor0.designation || '',
          sponsorId: sponsor0.sponsorId || sponsor0.associateId || '',
          idCard: sponsor0.idCard || '',
          email: sponsor0.email || '',
          phone: sponsor0.phone || '',
          city: sponsor0.city || '',
          state: sponsor0.state || '',
        });
        setRegistrationState({
          registrationDate: reg0.registrationDate || '',
          deActivationDate: reg0.deActivationDate || '',
        });
        setOtherState({
          employeeType: other0.employeeType || '',
          department: (profile.department || other0.department || ''),
          trialLastDate: other0.trialLastDate || '',
        });
        setPersonalState({
          fatherName: personal0.fatherName || '',
          dob: personal0.dob || '',
          anniversary: personal0.anniversary || '',
          qualification: personal0.qualification || '',
          addressNumber: personal0.addressNumber || '',
          pan: personal0.pan || '',
        });
        setBankState({
          accountName: bank0.accountName || '',
          bank: bank0.bank || bank0.bankName || '',
          accountNumber: bank0.accountNumber || '',
          ifsc: bank0.ifsc || bank0.ifscCode || '',
        });
        setNomineeState({
          name: nominee0.name || '',
          phone: nominee0.phone || '',
          relation: nominee0.relation || '',
        });
        setStatusState(Boolean(data?.status ?? true));
      } catch (e) {
        setFetchError(e?.response?.data?.message || e?.message || 'Failed to load profile');
      } finally {
        setLoadingProfile(false);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchBankData = async () => {
      try {
        const banks = await getBanks();
        setBankList(banks);
      } catch (error) {
        console.error('Error fetching banks:', error);
      }
    };
    fetchBankData();
  }, []);

  const canEditProfile = hasWritePermission('profile.my-profile');
  const conReadProfile = hasReadPermission('profile.my-profile');

  useEffect(() => {
    if (!canEditProfile && isEditing) {
      setIsEditing(false);
    }
  }, [canEditProfile, isEditing]);

  const sponsor = useMemo(() => {
    const s = (Array.isArray(profileData?.sponsorDetail) && profileData.sponsorDetail[0]) || profileData?.sponsorBy || {};
    return {
      ...s,
      sponsorName: s.sponsorName || s.name || '',
      sponsorId: s.sponsorId || s.associateId || '',
    };
  }, [profileData]);
  const registration = useMemo(() =>
    (Array.isArray(profileData?.registrationDetail) && profileData.registrationDetail[0]) || {},
    [profileData]);
  const other = useMemo(() =>
    (Array.isArray(profileData?.otherDetail) && profileData.otherDetail[0]) || {},
    [profileData]);
  const personal = useMemo(() =>
    (Array.isArray(profileData?.personalDetail) && profileData.personalDetail[0]) || {},
    [profileData]);
  const bank = useMemo(() =>
    (Array.isArray(profileData?.bankDetail) && profileData.bankDetail[0]) || {},
    [profileData]);
  const nominee = useMemo(() =>
    (Array.isArray(profileData?.nomineeDetail) && profileData.nomineeDetail[0]) || {},
    [profileData]);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setErrors({});
    setPersonalErrors({});
    setBankErrors({});
    setNomineeErrors({});
    setSuccessMessage('');
  };

  // Validation helper functions (defined before handlers that use them)
  const validatePhone = (phone) => {
    if (!phone) return 'Phone number is required';
    // Remove spaces, dashes, and parentheses
    const cleaned = phone.replace(/[\s\-\(\)]/g, '');
    // Check if starts with +91, remove it for validation
    const digits = cleaned.startsWith('+91') ? cleaned.slice(3) : cleaned;
    // Should be exactly 10 digits
    if (!/^\d{10}$/.test(digits)) {
      return 'Phone number must be 10 digits';
    }
    return '';
  };

  const validateEmail = (email) => {
    if (!email) return 'Email is required';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  const validatePAN = (pan) => {
    if (!pan) return ''; // PAN is optional, but if provided must be valid
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const upperPan = pan.toUpperCase().trim();
    if (!panRegex.test(upperPan)) {
      return 'PAN must be in format: AAAAA####A (5 letters, 4 digits, 1 letter)';
    }
    return '';
  };

  const validateAadhar = (aadhar) => {
    if (!aadhar) return ''; // Aadhar is optional, but if provided must be valid
    const cleaned = aadhar.replace(/[\s\-]/g, '');
    if (!/^\d{12}$/.test(cleaned)) {
      return 'Aadhar must be 12 digits';
    }
    return '';
  };

  const validateIFSC = (ifsc) => {
    if (!ifsc) return ''; // IFSC is optional, but if provided must be valid
    const upperIfsc = ifsc.toUpperCase().trim();
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    if (!ifscRegex.test(upperIfsc)) {
      return 'IFSC must be 11 characters (e.g., ABCD0123456)';
    }
    return '';
  };

  const validateAccountNumber = (accountNumber) => {
    if (!accountNumber) return ''; // Account number is optional, but if provided must be valid
    const cleaned = accountNumber.replace(/[\s\-]/g, '');
    if (!/^\d+$/.test(cleaned)) {
      return 'Account number must contain only digits';
    }
    if (cleaned.length < 9 || cleaned.length > 18) {
      return 'Account number must be between 9 and 18 digits';
    }
    return '';
  };

  // Handle profile input changes
  const handleProfileChange = (field, value) => {
    setProfile(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }

    // Real-time validation for phone and email
    if (field === 'phone') {
      const phoneError = validatePhone(value);
      if (phoneError || !value) {
        setErrors(prev => ({ ...prev, phone: phoneError }));
      } else {
        setErrors(prev => ({ ...prev, phone: '' }));
      }
    } else if (field === 'email') {
      const emailError = validateEmail(value);
      if (emailError || !value) {
        setErrors(prev => ({ ...prev, email: emailError }));
      } else {
        setErrors(prev => ({ ...prev, email: '' }));
      }
    } else if (field === 'mobile') {
      if (value) {
        const mobileError = validatePhone(value);
        if (mobileError) {
          setErrors(prev => ({ ...prev, mobile: mobileError }));
        } else {
          setErrors(prev => ({ ...prev, mobile: '' }));
        }
      } else {
        setErrors(prev => ({ ...prev, mobile: '' }));
      }
    }
  };


  if (!conReadProfile) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', p: 3 }}>
        <Paper elevation={3} sx={{ p: { xs: 3, md: 6 }, textAlign: 'center', maxWidth: 500, borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}>
          <AvatarMui sx={{ bgcolor: '#fee2e2', color: '#ef4444', width: 80, height: 80, mb: 3, mx: 'auto' }}>
            <WarningIcon sx={{ fontSize: 50 }} />
          </AvatarMui>
          <Typography variant="h4" fontWeight="bold" color="#1a202c" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, fontSize: '1.1rem' }}>
            You do not have permission to view the My Profile. Please contact your administrator for access.
          </Typography>
          <Button
            variant="contained"
            onClick={() => history.push('/app/dashboard')}
            sx={{
              backgroundColor: '#536DFE',
              '&:hover': { backgroundColor: '#3d5afe' },
              px: 4, py: 1.2, borderRadius: 2, fontWeight: 600, textTransform: 'none'
            }}
          >
            Back to Dashboard
          </Button>
        </Paper>
      </Box>
    );
  }

  // Handle password input changes
  const handlePasswordChange = (field, value) => {
    setPasswordData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Handle personal state changes with validation
  const handlePersonalChange = (field, value) => {
    setPersonalState(prev => ({ ...prev, [field]: value }));

    // Real-time validation
    if (field === 'pan') {
      const panError = validatePAN(value);
      if (panError || !value) {
        setPersonalErrors(prev => ({ ...prev, pan: panError }));
      } else {
        setPersonalErrors(prev => ({ ...prev, pan: '' }));
      }
    } else if (field === 'addressNumber') {
      const aadharError = validateAadhar(value);
      if (aadharError || !value) {
        setPersonalErrors(prev => ({ ...prev, addressNumber: aadharError }));
      } else {
        setPersonalErrors(prev => ({ ...prev, addressNumber: '' }));
      }
    } else if (personalErrors[field]) {
      setPersonalErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Handle bank state changes with validation
  const handleBankChange = (field, value) => {
    setBankState(prev => ({ ...prev, [field]: value }));

    // Real-time validation
    if (field === 'ifsc') {
      const ifscError = validateIFSC(value);
      if (ifscError || !value) {
        setBankErrors(prev => ({ ...prev, ifsc: ifscError }));
      } else {
        setBankErrors(prev => ({ ...prev, ifsc: '' }));
      }
    } else if (field === 'accountNumber') {
      const accountNumberError = validateAccountNumber(value);
      if (accountNumberError || !value) {
        setBankErrors(prev => ({ ...prev, accountNumber: accountNumberError }));
      } else {
        setBankErrors(prev => ({ ...prev, accountNumber: '' }));
      }
    } else if (bankErrors[field]) {
      setBankErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Handle nominee state changes with validation
  const handleNomineeChange = (field, value) => {
    setNomineeState(prev => ({ ...prev, [field]: value }));

    // Real-time validation
    if (field === 'phone') {
      if (value) {
        const phoneError = validatePhone(value);
        if (phoneError) {
          setNomineeErrors(prev => ({ ...prev, phone: phoneError }));
        } else {
          setNomineeErrors(prev => ({ ...prev, phone: '' }));
        }
      } else {
        setNomineeErrors(prev => ({ ...prev, phone: '' }));
      }
    } else if (nomineeErrors[field]) {
      setNomineeErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Validate profile form
  const validateProfile = () => {
    const newErrors = {};
    const newPersonalErrors = {};
    const newBankErrors = {};
    const newNomineeErrors = {};

    // Basic profile fields
    if (!profile.firstName) newErrors.firstName = 'First name is required';
    if (!profile.lastName) newErrors.lastName = 'Last name is required';

    const emailError = validateEmail(profile.email);
    if (emailError) newErrors.email = emailError;

    const phoneError = validatePhone(profile.phone);
    if (phoneError) newErrors.phone = phoneError;

    // Validate mobile if provided
    if (profile.mobile) {
      const mobileError = validatePhone(profile.mobile);
      if (mobileError) newErrors.mobile = mobileError;
    }

    // Personal details validation
    const panError = validatePAN(personalState.pan);
    if (panError) newPersonalErrors.pan = panError;

    const aadharError = validateAadhar(personalState.addressNumber);
    if (aadharError) newPersonalErrors.addressNumber = aadharError;

    // Bank details validation
    const ifscError = validateIFSC(bankState.ifsc);
    if (ifscError) newBankErrors.ifsc = ifscError;

    const accountNumberError = validateAccountNumber(bankState.accountNumber);
    if (accountNumberError) newBankErrors.accountNumber = accountNumberError;

    // Nominee validation
    if (nomineeState.phone) {
      const nomineePhoneError = validatePhone(nomineeState.phone);
      if (nomineePhoneError) newNomineeErrors.phone = nomineePhoneError;
    }

    setErrors(newErrors);
    setPersonalErrors(newPersonalErrors);
    setBankErrors(newBankErrors);
    setNomineeErrors(newNomineeErrors);

    const allErrors = {
      ...newErrors,
      ...newPersonalErrors,
      ...newBankErrors,
      ...newNomineeErrors,
    };

    return Object.keys(allErrors).length === 0;
  };

  // Validate password form
  const validatePassword = () => {
    const newErrors = {};
    if (!passwordData.currentPassword) newErrors.currentPassword = 'Current password is required';
    if (!passwordData.newPassword) newErrors.newPassword = 'New password is required';
    if (passwordData.newPassword && passwordData.newPassword.length < 6) {
      newErrors.newPassword = 'Password must be at least 6 characters';
    }
    if (!passwordData.confirmPassword) newErrors.confirmPassword = 'Confirm password is required';
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle save profile
  const handleSaveProfile = async () => {
    if (!canEditProfile) return;

    if (!validateProfile()) return;

    setIsLoading(true);
    try {
      const fullName = `${(profile.firstName || '').trim()} ${(profile.lastName || '').trim()}`.trim();

      // Construct the payload structure to match the API requirements
      const payload = {
        name: fullName,
        designation: profile.designation,
        email: profile.email,
        phone: profile.phone,
        whatsapp: profile.mobile,
        city: profile.city || '',
        state: profile.state || '',
        commission: profileData?.commission || '0',
        status: statusState,
        sponsorDetail: [
          {
            sponsorName: sponsorState.sponsorName,
            designation: sponsorState.designation,
            sponsorId: sponsorState.sponsorId,
            idCard: sponsorState.idCard,
            email: sponsorState.email,
            phone: sponsorState.phone,
            city: sponsorState.city,
            state: sponsorState.state,
          },
        ],
        registrationDetail: [
          {
            registrationDate: registrationState.registrationDate,
            deActivationDate: registrationState.deActivationDate,
          },
        ],
        otherDetail: [
          {
            employeeType: otherState.employeeType,
            department: otherState.department,
            trialLastDate: otherState.trialLastDate,
          },
        ],
        personalDetail: [
          {
            fatherName: personalState.fatherName,
            dob: personalState.dob,
            anniversary: personalState.anniversary,
            qualification: personalState.qualification,
            addressNumber: personalState.addressNumber,
            pan: personalState.pan,
          },
        ],
        bankDetail: [
          {
            accountName: bankState.accountName,
            bank: bankState.bank,
            accountNumber: bankState.accountNumber,
            ifsc: bankState.ifsc,
          },
        ],
        nomineeDetail: [
          {
            name: nomineeState.name,
            phone: nomineeState.phone,
            relation: nomineeState.relation,
          },
        ],
      };

      const formData = new FormData();
      // Append image if a new one was selected
      if (selectedFile) {
        formData.append('img', selectedFile);
      }

      // Append all other fields to FormData
      Object.keys(payload).forEach((key) => {
        const value = payload[key];
        if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
          // Details fields are sent as stringified arrays per the curl example
          formData.append(key, JSON.stringify(value));
        } else {
          // Top-level scalar fields
          formData.append(key, value === null ? '' : value);
        }
      });

      const resp = await updateProfile(formData);
      const isSuccess = resp?.status !== false;

      if (isSuccess) {
        try {
          showSnackbar({ type: 'success', message: resp?.message || 'Profile updated successfully' });
        } catch (err) { }
        setSuccessMessage(resp?.message || 'Profile updated successfully!');

        // Refresh profile data to reflect changes
        try {
          const freshData = await getProfileDetail();
          const updated = freshData?.data || freshData;
          setProfileData(updated || null);
          setAvatarPreview(null);
          setSelectedFile(null);
          window.dispatchEvent(new Event('profileUpdated'));
        } catch (err) { }

        setIsEditing(false);
        setTimeout(() => setSuccessMessage(''), 2500);
      } else {
        const errorMsg = resp?.message || 'Failed to update profile';
        try { showSnackbar({ type: 'error', message: errorMsg }); } catch (err) { }
      }
    } catch (error) {
      const topMsg = error?.message || error?.error || 'Failed to update profile. Please try again.';
      setErrors({ submit: topMsg });
      try { showSnackbar({ type: 'error', message: topMsg }); } catch (err) { }
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Send OTP for password change
  const handleSendOTP = async () => {
    if (!passwordData.currentPassword) {
      setErrors({ currentPassword: 'Current password is required' });
      return;
    }
    if (!passwordData.newPassword) {
      setErrors({ newPassword: 'New password is required' });
      return;
    }
    if (passwordData.newPassword.length < 6) {
      setErrors({ newPassword: 'Password must be at least 6 characters' });
      return;
    }

    setIsLoading(true);
    setErrors({});
    try {
      const resp = await sendPasswordOTP({
        id: profileData?._id || profileData?.id,
        oldPassword: passwordData.currentPassword
      });

      if (resp.success) {
        setOtpSent(true);
        showSnackbar({ type: 'success', message: resp.message || 'OTP sent successfully' });
      } else {
        setErrors({ submit: resp.message || 'Failed to send OTP' });
        showSnackbar({ type: 'error', message: resp.message || 'Failed to send OTP' });
      }
    } catch (error) {
      setErrors({ submit: error.message || 'Failed to send OTP' });
      showSnackbar({ type: 'error', message: error.message || 'Failed to send OTP' });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Verify OTP and Change Password
  const handleChangePassword = async () => {
    if (!otp) {
      setErrors({ otp: 'OTP is required' });
      return;
    }

    setIsLoading(true);
    setErrors({});
    try {
      const resp = await verifyPasswordOTP({
        id: profileData?._id || profileData?.id,
        otp: otp,
        newPassword: passwordData.newPassword
      });

      if (resp.success) {
        showSnackbar({ type: 'success', message: resp.message || 'Password changed successfully' });
        setSuccessMessage('Password changed successfully!');
        setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
        setOtp('');
        setOtpSent(false);
        setActiveTab(0); // Optional: go back to profile
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        setErrors({ submit: resp.message || 'Failed to verify OTP' });
        showSnackbar({ type: 'error', message: resp.message || 'Failed to verify OTP' });
      }
    } catch (error) {
      setErrors({ submit: error.message || 'Failed to change password' });
      showSnackbar({ type: 'error', message: error.message || 'Failed to change password' });
    } finally {
      setIsLoading(false);
    }
  };

  // Formatting & section helpers
  const formatDateOnly = (v, placeholder = 'N/A') => {
    if (!v) return placeholder;
    const dateOnlyMatch = typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);
    const d = dateOnlyMatch ? new Date(v + 'T00:00:00') : new Date(v);
    if (Number.isNaN(d.getTime())) return placeholder;
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit' });
  };

  const formatDateTime = (v, placeholder = 'N/A') => {
    if (!v) return placeholder;
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return placeholder;
    return d.toLocaleString(undefined, {
      year: 'numeric', month: 'short', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true,
    });
  };

  const safe = (v, placeholder = 'N/A') => {
    if (v === null || v === undefined) return placeholder;
    if (typeof v === 'string' && v.trim() === '') return placeholder;
    return v;
  };


  // Kept, even if not used now (no functional impact)
  const InfoItem = ({ label, value }) => (
    <Grid item xs={12} sm={6} md={4}>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography variant="body1" sx={{ fontWeight: 600 }}>{safe(value)}</Typography>
    </Grid>
  );

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      {/* Header */}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, gap: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <PersonIcon sx={{ fontSize: 40, color: 'primary.main' }} />
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
              My Profile
            </Typography>
            <Typography variant="body2" color="text.secondary">
              View and manage your personal information
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
          {loadingProfile && <CircularProgress size={20} />}
          {profileData?.createdAt && (
            <Chip size="small" color="default" label={`Created: ${formatDateTime(profileData.createdAt)}`} />
          )}
          {profileData?.updatedAt && (
            <Chip size="small" color="default" label={`Updated: ${formatDateTime(profileData.updatedAt)}`} />
          )}
        </Box>
      </Box>

      {/* Success/Error Messages */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMessage}
        </Alert>
      )}
      {fetchError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {fetchError}
        </Alert>
      )}
      {errors.submit && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errors.submit}
        </Alert>
      )}

      <Grid container spacing={3}>
        {/* Profile Card - Left Side */}
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <Box sx={{ position: 'relative', display: 'inline-block', mb: 2 }}>
                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="icon-button-file"
                  type="file"
                  onChange={handleImageChange}
                  disabled={!isEditing}
                />
                <label htmlFor="icon-button-file">
                  <Avatar
                    src={avatarPreview || (profileData?.img || profileData?.imgUrl)}
                    sx={{
                      width: 150,
                      height: 150,
                      margin: '0 auto',
                      backgroundColor: 'primary.main',
                      fontSize: 60,
                      cursor: isEditing ? 'pointer' : 'default'
                    }}
                  >
                    {!avatarPreview && !profileData?.img && !profileData?.imgUrl && (
                      <>
                        {profile.firstName.charAt(0)}{profile.lastName.charAt(0)}
                      </>
                    )}
                  </Avatar>
                </label>
                <IconButton
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    backgroundColor: 'white',
                    boxShadow: 2,
                    '&:hover': { backgroundColor: 'grey.100' },
                  }}
                  size="small"
                  disabled={!isEditing}
                  onClick={() => document.getElementById('icon-button-file').click()}
                >
                  <CameraIcon />
                </IconButton>
              </Box>
              <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                {profile.firstName} {profile.lastName}
              </Typography>
              <Typography variant="body2" color="primary" sx={{ mb: 1 }}>
                {profile.designation}
              </Typography>
              {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {profile.department} Department
              </Typography> */}
              <Divider sx={{ my: 2 }} />
              <Box sx={{ textAlign: 'left' }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  <strong>Associate ID:</strong> {profile.loginId}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  <strong>Joining Date:</strong> {formatDateOnly(profile.joiningDate)}
                </Typography>
                {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  <strong>Sponsor :</strong> {profile.reportingTo}
                </Typography> */}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Profile Details - Right Side */}
        <Grid item xs={12} md={8}>
          <Paper
            sx={{
              p: 0,
              borderRadius: 3,
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(15,23,42,0.08)',
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                px: 2,
                backgroundColor: 'grey.50',
              }}
            >
              <Tab label="Personal Information" />
              <Tab label="Change Password" />
            </Tabs>

            {/* Personal Information Tab */}
            <TabPanel value={activeTab} index={0}>
              <Box sx={{ px: 2, pb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, flexWrap: 'wrap' }}>
                  {canEditProfile ? (
                    !isEditing ? (
                      <Button
                        variant="contained"
                        startIcon={<EditIcon />}
                        onClick={() => setIsEditing(true)}
                        sx={{ textTransform: 'none' }}
                      >
                        Edit Profile
                      </Button>
                    ) : (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          variant="outlined"
                          onClick={() => setIsEditing(false)}
                          disabled={isLoading}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={isLoading ? <CircularProgress size={20} /> : <SaveIcon />}
                          onClick={handleSaveProfile}
                          disabled={isLoading}
                        >
                          {isLoading ? 'Saving...' : 'Save Changes'}
                        </Button>
                      </Box>
                    )
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      Profile updates are restricted. Please contact an administrator.
                    </Typography>
                  )}
                </Box>

                {/* Basic Information / Contact / Address cards (editable) */}
                <Grid container spacing={2}>
                  {/* Basic Information Card */}
                  <Grid item xs={12}>
                    <Card
                      variant="outlined"
                      sx={{
                        borderRadius: 2,
                        backgroundColor: 'grey.50',
                        boxShadow: 'none',
                      }}
                    >
                      <CardContent sx={{ pb: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                          Basic Information
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Name *"
                              value={profile.firstName}
                              onChange={(e) => handleProfileChange('firstName', e.target.value)}
                              disabled={true}
                              error={Boolean(errors.firstName)}
                              helperText={errors.firstName}
                              size="small"
                            />
                          </Grid>
                          {/* <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Last Name *"
                              value={profile.lastName}
                              onChange={(e) => handleProfileChange('lastName', e.target.value)}
                              disabled={!isEditing}
                              error={Boolean(errors.lastName)}
                              helperText={errors.lastName}
                              size="small"
                            />
                          </Grid> */}
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Date of Birth"
                              type="date"
                              value={profile.dateOfBirth}
                              onChange={(e) => handleProfileChange('dateOfBirth', e.target.value)}
                              disabled={!isEditing}
                              InputLabelProps={{ shrink: true }}
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Contact Details Card */}
                  <Grid item xs={12}>
                    <Card
                      variant="outlined"
                      sx={{
                        borderRadius: 2,
                        backgroundColor: 'grey.50',
                        boxShadow: 'none',
                      }}
                    >
                      <CardContent sx={{ pb: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                          Contact Details
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Email *"
                              type="email"
                              value={profile.email}
                              onChange={(e) => handleProfileChange('email', e.target.value)}
                              disabled={true}
                              error={Boolean(errors.email)}
                              helperText={errors.email}
                              size="small"
                              InputProps={{
                                startAdornment: (
                                  <EmailIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Phone *"
                              value={profile.phone}
                              onChange={(e) => handleProfileChange('phone', e.target.value)}
                              disabled={true}
                              error={Boolean(errors.phone)}
                              helperText={errors.phone}
                              size="small"
                              InputProps={{
                                startAdornment: (
                                  <PhoneIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Mobile"
                              value={profile.mobile}
                              onChange={(e) => handleProfileChange('mobile', e.target.value)}
                              disabled={true}
                              error={Boolean(errors.mobile)}
                              helperText={errors.mobile}
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Address Card */}
                  <Grid item xs={12}>
                    <Card
                      variant="outlined"
                      sx={{
                        borderRadius: 2,
                        backgroundColor: 'grey.50',
                        boxShadow: 'none',
                      }}
                    >
                      <CardContent sx={{ pb: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                          Address
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Address"
                              value={profile.address}
                              onChange={(e) => handleProfileChange('address', e.target.value)}
                              disabled={!isEditing}
                              size="small"
                              InputProps={{
                                startAdornment: (
                                  <LocationIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                ),
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="State"
                              value={profile.state}
                              onChange={(e) => handleProfileChange('state', e.target.value)}
                              disabled={!isEditing}
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="City"
                              value={profile.city}
                              onChange={(e) => handleProfileChange('city', e.target.value)}
                              disabled={!isEditing}
                              size="small"
                            />
                          </Grid>
                          {/* <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Country"
                      value={profile.country}
                      onChange={(e) => handleProfileChange('country', e.target.value)}
                      disabled={!isEditing}
                              size="small"
                    />
                  </Grid> */}
                          {/* <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Postal Code"
                      value={profile.postalCode}
                      onChange={(e) => handleProfileChange('postalCode', e.target.value)}
                      disabled={!isEditing}
                              size="small"
                            />
                          </Grid> */}
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                {/* DETAILED INFORMATION SECTION NOW ALSO IN CARDS WITH INPUTS */}
                {profileData && (
                  <Box sx={{ mt: 3 }}>
                    <Divider sx={{ mb: 2 }} />
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
                      Detailed Information
                    </Typography>

                    <Grid container spacing={2}>
                      {/* Basic (Detailed) */}
                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            boxShadow: 'none',
                          }}
                        >
                          <CardContent sx={{ pb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                              Basic
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Associate ID"
                                  value={safe(profileData.credentials.loginId || profile.employeeId)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <BadgeIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Name"
                                  value={safe(profileData.name)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PersonIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Designation"
                                  value={safe(profileData.designation)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <BadgeIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Email"
                                  value={safe(profileData.email)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <EmailIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Phone"
                                  value={safe(profileData.phone)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PhoneIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="WhatsApp"
                                  value={safe(profileData.whatsapp)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PhoneIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              {/* <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="City"
                                  value={safe(profileData.city)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <LocationIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid> */}
                              {/* <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="State"
                                  value={safe(profileData.state)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <LocationIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid> */}
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Commission"
                                  value={safe(profileData.commission)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PaymentIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Sponsor Detail */}
                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            boxShadow: 'none',
                          }}
                        >
                          <CardContent sx={{ pb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                              Sponsor Detail
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  disabled={true}
                                  label="Sponsor Name"
                                  value={isEditing ? sponsorState.sponsorName : safe(sponsor.sponsorName)}
                                  onChange={(e) => setSponsorState(s => ({ ...s, sponsorName: e.target.value }))}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PersonIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Sponsor ID"
                                  value={isEditing ? sponsorState.sponsorId : safe(sponsor.sponsorId)}
                                  onChange={(e) => setSponsorState(s => ({ ...s, sponsorId: e.target.value }))}
                                  disabled={true}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <BadgeIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Email"
                                  value={isEditing ? sponsorState.email : safe(sponsor.email)}
                                  onChange={(e) => setSponsorState(s => ({ ...s, email: e.target.value }))}
                                  disabled={true}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <EmailIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Phone"
                                  value={isEditing ? sponsorState.phone : safe(sponsor.phone)}
                                  onChange={(e) => setSponsorState(s => ({ ...s, phone: e.target.value }))}
                                  disabled={true}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PhoneIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              {/* <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="City"
                                  value={isEditing ? sponsorState.city : safe(sponsor.city)}
                                  onChange={(e) => setSponsorState(s => ({ ...s, city: e.target.value }))}
                                  disabled={!isEditing}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <LocationIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid> */}
                              {/* <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="State"
                                  value={isEditing ? sponsorState.state : safe(sponsor.state)}
                                  onChange={(e) => setSponsorState(s => ({ ...s, state: e.target.value }))}
                                  disabled={!isEditing}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <LocationIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid> */}
                              {/* <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Designation"
                                  value={isEditing ? sponsorState.designation : safe(sponsor.designation)}
                                  onChange={(e) => setSponsorState(s => ({ ...s, designation: e.target.value }))}
                                  disabled={!isEditing}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <BadgeIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid> */}
                              {/* <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="ID Card"
                                  value={isEditing ? sponsorState.idCard : safe(sponsor.idCard)}
                                  onChange={(e) => setSponsorState(s => ({ ...s, idCard: e.target.value }))}
                                  disabled={!isEditing}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid> */}
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Registration */}
                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            boxShadow: 'none',
                          }}
                        >
                          <CardContent sx={{ pb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                              Registration
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Registration Date"
                                  type="date"
                                  value={isEditing ? (registrationState.registrationDate || '') : (registration.registrationDate || '')}
                                  onChange={(e) => setRegistrationState(s => ({ ...s, registrationDate: e.target.value }))}
                                  disabled={true}
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  InputProps={{
                                    startAdornment: (
                                      <CalendarIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              {/* <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="De-Activation Date"
                                  type="date"
                                  value={isEditing ? (registrationState.deActivationDate || '') : (registration.deActivationDate || '')}
                                  onChange={(e) => setRegistrationState(s => ({ ...s, deActivationDate: e.target.value }))}
                                  disabled={true}
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  InputProps={{
                                    startAdornment: (
                                      <CalendarIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid> */}
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Other Detail */}
                      <Grid item xs={12} display="none">
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            boxShadow: 'none',
                          }}
                        >
                          <CardContent sx={{ pb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                              Other Detail
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Employee Type"
                                  value={isEditing ? otherState.employeeType : safe(other.employeeType)}
                                  onChange={(e) => setOtherState(s => ({ ...s, employeeType: e.target.value }))}
                                  disabled={true}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Department"
                                  value={isEditing ? otherState.department : safe(other.department)}
                                  onChange={(e) => setOtherState(s => ({ ...s, department: e.target.value }))}
                                  disabled={true}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Trial Last Date"
                                  type="date"
                                  value={isEditing ? (otherState.trialLastDate || '') : (other.trialLastDate || '')}
                                  onChange={(e) => setOtherState(s => ({ ...s, trialLastDate: e.target.value }))}
                                  disabled={true}
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  InputProps={{
                                    startAdornment: (
                                      <CalendarIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Personal */}
                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            boxShadow: 'none',
                          }}
                        >
                          <CardContent sx={{ pb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                              Personal
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Father Name"
                                  value={isEditing ? personalState.fatherName : safe(personal.fatherName)}
                                  onChange={(e) => handlePersonalChange('fatherName', e.target.value)}
                                  disabled={!isEditing}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PersonIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="DOB"
                                  type="date"
                                  value={isEditing ? (personalState.dob || '') : (personal.dob || '')}
                                  onChange={(e) => handlePersonalChange('dob', e.target.value)}
                                  disabled={!isEditing}
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  InputProps={{
                                    startAdornment: (
                                      <CalendarIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Anniversary"
                                  type="date"
                                  value={isEditing ? (personalState.anniversary || '') : (personal.anniversary || '')}
                                  onChange={(e) => handlePersonalChange('anniversary', e.target.value)}
                                  disabled={!isEditing}
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  InputProps={{
                                    startAdornment: (
                                      <CalendarIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Aadhar"
                                  value={isEditing ? personalState.addressNumber : safe(personal.addressNumber)}
                                  onChange={(e) => handlePersonalChange('addressNumber', e.target.value)}
                                  disabled={!isEditing}
                                  error={Boolean(personalErrors.addressNumber)}
                                  helperText={personalErrors.addressNumber}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="PAN"
                                  value={isEditing ? personalState.pan : safe(personal.pan)}
                                  onChange={(e) => handlePersonalChange('pan', e.target.value.toUpperCase())}
                                  disabled={!isEditing}
                                  error={Boolean(personalErrors.pan)}
                                  helperText={personalErrors.pan}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Bank Details */}
                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            boxShadow: 'none',
                          }}
                        >
                          <CardContent sx={{ pb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                              Bank Details
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Account Name"
                                  value={isEditing ? bankState.accountName : safe(bank.accountName)}
                                  onChange={(e) => handleBankChange('accountName', e.target.value)}
                                  disabled={!isEditing}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <AccountCircleIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Autocomplete
                                  fullWidth
                                  options={bankList}
                                  getOptionLabel={(option) => {
                                    if (typeof option === 'string') return option;
                                    return option.name || '';
                                  }}
                                  value={isEditing ? bankList.find(b => b.name === bankState.bank) || bankState.bank : safe(bank.bank)}
                                  onChange={(event, newValue) => {
                                    handleBankChange('bank', newValue ? (newValue.name || newValue) : '');
                                  }}
                                  disabled={!isEditing}
                                  freeSolo
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Bank"
                                      size="small"
                                      disabled={!isEditing}
                                      InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                          <>
                                            <InputAdornment position="start">
                                              <BankIcon sx={{ color: 'action.active', fontSize: 20 }} />
                                            </InputAdornment>
                                            {params.InputProps.startAdornment}
                                          </>
                                        ),
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Account Number"
                                  value={isEditing ? bankState.accountNumber : safe(bank.accountNumber)}
                                  onChange={(e) => handleBankChange('accountNumber', e.target.value)}
                                  disabled={!isEditing}
                                  error={Boolean(bankErrors.accountNumber)}
                                  helperText={bankErrors.accountNumber}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PaymentIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="IFSC"
                                  value={isEditing ? bankState.ifsc : safe(bank.ifsc)}
                                  onChange={(e) => handleBankChange('ifsc', e.target.value.toUpperCase())}
                                  disabled={!isEditing}
                                  error={Boolean(bankErrors.ifsc)}
                                  helperText={bankErrors.ifsc}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Nominee */}
                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            boxShadow: 'none',
                          }}
                        >
                          <CardContent sx={{ pb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                              Nominee
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Name"
                                  value={isEditing ? nomineeState.name : safe(nominee.name)}
                                  onChange={(e) => handleNomineeChange('name', e.target.value)}
                                  disabled={!isEditing}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <AccountCircleIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Phone"
                                  value={isEditing ? nomineeState.phone : safe(nominee.phone)}
                                  onChange={(e) => handleNomineeChange('phone', e.target.value)}
                                  disabled={!isEditing}
                                  error={Boolean(nomineeErrors.phone)}
                                  helperText={nomineeErrors.phone}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PhoneIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Relation"
                                  value={isEditing ? nomineeState.relation : safe(nominee.relation)}
                                  onChange={(e) => setNomineeState(s => ({ ...s, relation: e.target.value }))}
                                  disabled={!isEditing}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Meta */}
                      <Grid item xs={12} display="none">
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            boxShadow: 'none',
                          }}
                        >
                          <CardContent sx={{ pb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                              Meta
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={4}>
                                {isEditing ? (
                                  <FormControlLabel
                                    control={<Switch checked={Boolean(statusState)} onChange={(e) => setStatusState(e.target.checked)} />}
                                    label={Boolean(statusState) ? 'Status: Active' : 'Status: Inactive'}
                                  />
                                ) : (
                                  <TextField
                                    fullWidth
                                    label="Status"
                                    value={profileData.status ? 'true' : 'false'}
                                    disabled
                                    size="small"
                                    InputProps={{
                                      startAdornment: (
                                        <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                      ),
                                    }}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <TextField
                                  fullWidth
                                  label="Is Active"
                                  value={profileData.isActive ? 'true' : 'false'}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <TextField
                                  fullWidth
                                  label="Is Deleted"
                                  value={profileData.isDeleted ? 'true' : 'false'}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InfoIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <TextField
                                  fullWidth
                                  label="Created By"
                                  value={safe(profileData.createdBy)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <PersonIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <TextField
                                  fullWidth
                                  label="Created At"
                                  value={formatDateTime(profileData.createdAt)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <CalendarIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <TextField
                                  fullWidth
                                  label="Updated At"
                                  value={formatDateTime(profileData.updatedAt)}
                                  disabled
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <CalendarIcon sx={{ mr: 1, color: 'action.active', fontSize: 20 }} />
                                    ),
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Box>
            </TabPanel>

            <TabPanel value={activeTab} index={1}>
              <Box sx={{ px: 2, pb: 2, maxWidth: 600 }}>
                <Grid container spacing={2}>
                  {!otpSent ? (
                    <>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          type={showCurrentPassword ? "text" : "password"}
                          label="Current Password *"
                          value={passwordData.currentPassword}
                          onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
                          error={Boolean(errors.currentPassword)}
                          helperText={errors.currentPassword}
                          InputProps={{
                            startAdornment: <LockIcon sx={{ mr: 1, color: 'action.active' }} />,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                  edge="end"
                                >
                                  {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          type={showNewPassword ? "text" : "password"}
                          label="New Password *"
                          value={passwordData.newPassword}
                          onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                          error={Boolean(errors.newPassword)}
                          helperText={errors.newPassword || 'Password must be at least 6 characters'}
                          InputProps={{
                            startAdornment: <LockIcon sx={{ mr: 1, color: 'action.active' }} />,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => setShowNewPassword(!showNewPassword)}
                                  edge="end"
                                >
                                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          startIcon={isLoading ? <CircularProgress size={20} /> : <SaveIcon />}
                          onClick={handleSendOTP}
                          disabled={isLoading}
                          sx={{ mt: 2 }}
                        >
                          {isLoading ? 'Sending OTP...' : 'Send OTP'}
                        </Button>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="OTP *"
                          placeholder="Enter 6-digit OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          error={Boolean(errors.otp)}
                          helperText={errors.otp}
                          InputProps={{
                            startAdornment: <BadgeIcon sx={{ mr: 1, color: 'action.active' }} />,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="success"
                          startIcon={isLoading ? <CircularProgress size={20} /> : <LockIcon />}
                          onClick={handleChangePassword}
                          disabled={isLoading}
                          sx={{ mt: 2 }}
                        >
                          {isLoading ? 'Verifying...' : 'Change Password'}
                        </Button>
                        <Button
                          fullWidth
                          variant="text"
                          onClick={() => setOtpSent(false)}
                          disabled={isLoading}
                          sx={{ mt: 1 }}
                        >
                          Back to inputs
                        </Button>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Box>
            </TabPanel>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MyProfile;
